import { Invoice } from '../../common';
import { en } from '../theme/languages/en';
import { InvoiceSummaryData, SummaryItems } from '../types';
import { handleValueWithNisCurrency } from './general';
import { styles } from '../components/SummaryData/SummaryData.module';

export const invoiceSummaryValuesList = ({
  subTotalCalculatedValue,
  discountCalculatedValue,
  taxPercentage,
  taxCalculatedValue,
  hidePercentage,
  isCreditsExist,
  discount,
  totalDue,
  credits,
  creditEstimations,
  currency,
  isPartialPeriod,
}: InvoiceSummaryData): SummaryItems[] => {
  return [
    {
      title: en.subTotal,
      value: handleValueWithNisCurrency(currency, subTotalCalculatedValue),
      isVisible: true,
    },
    {
      title: hidePercentage ? en.discount : `${en.discount} (${discount}%)`,
      value: discountCalculatedValue
        ? `(${handleValueWithNisCurrency(currency, discountCalculatedValue)})`
        : `(${handleValueWithNisCurrency(currency, 0)})`,
      isVisible: !!discount || !!discountCalculatedValue,
    },
    {
      title: hidePercentage ? en.tax : `${en.tax} (${taxPercentage}%)`,
      value: handleValueWithNisCurrency(currency, taxCalculatedValue),
      isVisible: !!taxPercentage || !!taxCalculatedValue,
    },
    {
      title: en.total,
      value: handleValueWithNisCurrency(currency, totalDue),
      isVisible: isCreditsExist || !!creditEstimations,
      labelStyle: { fontWeight: 700 },
      amountStyle: { fontWeight: 700 },
    },
    {
      title: en.paidCredits,
      value: `(${handleValueWithNisCurrency(currency, credits || creditEstimations)})`,
      isVisible: isCreditsExist || !!creditEstimations,
    },
    {
      title: en.totalDue,
      value: handleValueWithNisCurrency(currency, totalDue),
      isVisible: true,
      containerStyle: styles.totalSumSection,
      labelStyle: [styles.boldText, { marginTop: 5 }],
      amountStyle: styles.boldText,
      isPartialPeriod: isPartialPeriod,
    },
  ];
};

export const getInvoiceIdName = (invoice: Invoice) => {
  if (invoice?.documentNumber) {
    return `${invoice?.documentNumber}`;
  } else if (invoice?.customNumber) {
    return invoice?.customNumber;
  } else if (invoice?.draftNumber) {
    return invoice?.draftNumber;
  } else {
    return '';
  }
};
